import comp from "./AddEvidenceModalWrapper";
export default comp;
